<script>
import { required } from "@vuelidate/validators";

import Button from "@/components/atoms/button";
import FormGroup from "@/components/molecules/form-group";
import Form from "@/components/molecules/form";
import FormInput from "@/components/molecules/form-input";
import Titre from "@/components/atoms/titre";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";

export default {
  name: "CommandeNommer",
  components: { Button, FormGroup, Form, FormInput, Titre },
  props: {
    name: {
      type: String,
      required: false,
      default: ""
    },
    ...formValidationProps()
  },
  emits: ["validate"],
  setup(props) {
    const { v$, getState, getErrorMessage, checkValidation } =
      useFormValidation(props);
    return {
      v$,
      getState,
      getErrorMessage,
      checkValidation
    };
  },
  data() {
    return {
      titre: ""
    };
  },
  validations() {
    return {
      titre: {
        required
      }
    };
  },
  methods: {
    validate() {
      if (this.checkValidation(this.v$)) {
        this.$emit("validate", this.titre);
      }
    }
  },
  watch: {
    name: {
      handler(val) {
        this.titre = val;
      },
      immediate: true
    }
  }
};
</script>

<template>
  <div class="u-text-center">
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-mb-md"
    >
      <template v-if="name">
        Renommer
      </template>
      <template v-else>
        Nommer
      </template>
      votre commande
    </Titre>
    <Form @submit.prevent="validate()">
      <FormGroup
        class="u-mb-lg"
        center
        :state="getState(v$,'titre')"
      >
        <FormInput
          v-model.trim="titre"
          :state="getState(v$,'titre')"
          @blur="v$.titre.$touch()"
          @input="v$.titre.$reset()"
        >
          Nom de la commande*
        </FormInput>
        <template #message>
          {{ getErrorMessage("titre","Merci de renseigner un titre") }}
        </template>
      </FormGroup>
      <Button
        variant="primary"
        radius="full"
        size="md"
        type="submit"
        value="Valider"
      />
    </Form>
  </div>
</template>

<style lang="scss" scoped>
</style>
